<template>
	<JBox class="s-w-full">
		<!-- Header -->
		<JFlex class="s-items-center s-justify-end s-bg-gray-50 s-p-4">
			<JFlex>
				<JButton variant="default-light-sm" class="s-mr-2" @click="toggleTemplateList">{{
					$t("templates.addTemplateAsAttachment")
				}}</JButton>
				<JButton variant="default-light-sm" @click="toggleFileExplorer">{{ $t("templates.addFile") }}</JButton>
			</JFlex>
		</JFlex>

		<!-- Body -->
		<JFlex class="s-flex-wrap s-bg-white s-px-4 s-pb-4">
			<JFlex v-for="(item, i) in attachments" :key="i" class="s-mr-4 s-mt-4 s-w-5/12 s-bg-gray-100 s-p-4">
				<JFlex class="s-flex-col s-p-1 s-justify-between">
					<JBox>
						<div class="s-text-sm s-overflow-hidden s-text-gray-900 s-font-medium">{{ item.fileName }}</div>
						<div class="s-text-sm s-overflow-hidden s-text-gray-700 s-font-thin" v-if="item.type === 'file'">
							{{ item.filePath }}
						</div>
						<div class="s-text-sm s-overflow-hidden s-text-gray-700 s-font-thin" v-if="item.id">{{ item.id }}</div>
						<div class="s-text-xs s-overflow-hidden s-text-gray-700 s-mb-4">{{ item.type.toUpperCase() }}</div>
					</JBox>
					<div class="s-text-indigo-500 s-cursor-pointer s-font-medium s-underline" @click="onDownload(item)">
						{{ $t("templates.download") }}
					</div>
				</JFlex>
				<!-- Cross -->
				<svg
					@click="onRemove(item)"
					class=" s-cursor-pointer s-ml-auto s-text-gray-500 hover:s-text-gray-900 "
					height="16"
					width="16"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M6 18L18 6M6 6l12 12"></path>
				</svg>
			</JFlex>
		</JFlex>

		<!-- List of pdfDrawing and wkhtml2Pdf Templates that can be added as attachment -->
		<CModal :isVisible="showTemplateList">
			<JBox class="s-bg-white s-p-4 s-rounded">
				<JLabel>{{ $t("templates.selectTemplate") }}</JLabel>
				<JSelect valueKey="id" :options="templateOptions" v-model="selectedTemplateId" />
				<JFlex class="s-mt-4 s-justify-end">
					<JButton class="s-mr-2" variant="white" @click="toggleTemplateList">{{ $t("templates.cancel") }}</JButton>
					<JButton @click="onTemplateSelect">{{ $t("templates.add") }}</JButton>
				</JFlex>
			</JBox>
		</CModal>

		<!-- File Explorer -->
		<CModal variant="default-large" :isVisible="showFileExplorer" @overlay:click="toggleFileExplorer">
			<JBox class="s-bg-white">
				<CFilesExplorer :isFilePicker="true" @file:selected="onFileSelect" @file:multiSelected="onMultiFileSelect" />
			</JBox>
		</CModal>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { query, mutation } from "../../api/queries"
import { downloadFile } from "@/utils/"

export default {
	props: {
		templateId: {
			type: String,
			required: true
		},
		attachments: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			showFileExplorer: false,
			showTemplateList: false,
			templateOptions: [],
			selectedTemplateId: null
		}
	},

	methods: {
		removeAttachment(item) {
			alert("removing", item)
		},
		onFileSelect(file) {
			if (!file) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: this.$t("templates.generalError") }
				})
			} else this.addEmailAttachmentReference(file)
			this.toggleFileExplorer()
		},
		onMultiFileSelect(files) {
			if (files && files.length) {
				files.forEach(file => this.addEmailAttachmentReference(file))
			} else {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: this.$t("templates.generalError") }
				})
			}
			this.toggleFileExplorer()
		},
		toggleFileExplorer() {
			this.showFileExplorer = !this.showFileExplorer
		},
		async toggleTemplateList() {
			this.showTemplateList = await !this.showTemplateList
			if (this.showTemplateList) {
				this.fetchTemplates()
			} else return
		},
		async addEmailAttachmentReference(file) {
			const variables = { templateId: this.templateId, input: { fileName: file.fileName, filePath: file.path } }
			const res = await api({ query: mutation.addEmailAttachmentReference, variables })
			if (res?.data?.addEmailAttachmentReference?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.addEmailAttamchentReference?.errors?.[0] }
				})
			}
			this.$emit("attachment:added")
		},
		async fetchTemplates() {
			const variables = { where: { or: [{ type: "pdfDrawing" }, { type: "wkhtmltopdf" }] } }
			const res = await api({ query: query.fetchTemplatesByType, variables })
			this.templateOptions = res?.data?.templates?.list
		},
		async onTemplateSelect() {
			await this.addEmailAttachmentTemplate()
			this.selectedTemplateId = null
			this.toggleTemplateList()
		},
		async addEmailAttachmentTemplate() {
			const fileName = this.templateOptions?.find(item => item.id === this.selectedTemplateId)?.name + ".pdf"
			const variables = { templateId: this.templateId, input: { fileName: fileName, templateId: this.selectedTemplateId } }
			const res = await api({ query: mutation.addEmailAttachmentTemplate, variables })
			if (res?.data?.addEmailAttachmentTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.addEmailAttachmentTemplate?.errors?.[0] }
				})
			} else
				this.$store.dispatch("addToastMessage", {
					type: "success",
					content: { type: "message", text: this.$t("templates.addedAttachment") }
				})
			this.$emit("attachment:added")
		},
		onRemove(item) {
			if (!item) return
			else if (item.type === "file") {
				this.removeEmailAttachmentReference(item.id)
			} else if (item.type === "template") {
				this.removeEmailAttachmentTemplate(item.attachmentTemplateId)
			}
		},
		async removeEmailAttachmentReference(id) {
			const variables = { templateId: this.templateId, attachmentReferenceId: id }
			const res = await api({ query: mutation.removeEmailAttachmentReference, variables })
			if (res?.data?.removeEmailAttachmentReference?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.removeEmailAttachmentReference?.errors?.[0] }
				})
			}
			this.$emit("attachment:removed")
		},
		async removeEmailAttachmentTemplate(id) {
			const variables = { templateId: this.templateId, attachmentTemplateId: id }
			const res = await api({ query: mutation.removeEmailAttachmentTemplate, variables })
			if (res?.data?.removeEmailAttachmentTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.removeEmailAttachmentTemplate?.errors?.[0] }
				})
			}
			this.$emit("attachment:removed")
		},
		onDownload(attachment) {
			const { fileName } = attachment
			if (attachment.type === "file") this.downloadAttachedFile(fileName)
			else if (attachment.type === "template") this.downloadAttachedTemplate(fileName)
			else return
		},
		async renderEmailAttachments() {
			const variables = { templateId: this.templateId, includeAttachments: true }
			const res = await api({ query: query.renderEmailAttachments, variables })

			if (res?.data?.renderEmailMjmlTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.renderEmailMjmlTemplate?.errors?.[0] }
				})
			}

			return res?.data?.renderEmailMjmlTemplate?.value?.attachments
		},

		async downloadAttachedFile(fileName) {
			let attachments = await this.renderEmailAttachments()
			let found = attachments?.find(item => item?.fileName === fileName)
			if (!found) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: this.$t("templates.fileDoesNotExist") }
				})
			}
			downloadFile(found?.bytes, found?.fileName)
		},
		async downloadAttachedTemplate(fileName) {
			let attachments = await this.renderEmailAttachments()
			let found = attachments?.find(item => item?.fileName === fileName)
			if (!found) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: this.$t("templates.templateDoesNotExist") }
				})
			}
			downloadFile(found?.bytes, found?.fileName, "application/pdf")
		}
	}
}
</script>
